<mat-card>
    <mat-card-title class="mat-align-center text-primary text-center"> Alterar Status </mat-card-title>
    <mat-card-content>
        <mat-form-field appearance="fill">
            <mat-label>Status do PIX</mat-label>
            <mat-select (selectionChange)="onStatusPixChanged($event)" [(ngModel)]="newPixStatusSelected">
                <mat-option [value]="PixStatusEnum.Success">Recebido</mat-option>
                <mat-option [value]="PixStatusEnum.Error">Erros</mat-option>
            </mat-select> </mat-form-field
        ><mat-form-field appearance="fill" class="w-100">
            <mat-label>Descrição</mat-label>
            <textarea
                matInput
                [(ngModel)]="description"
                rows="4"
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="4"
                cdkAutosizeMaxRows="10">
            </textarea>
        </mat-form-field>
    </mat-card-content>
    <mat-card-actions align="end">
        <button mat-raised-button color="primary" class="btn-sm" (click)="confirm()">
            <mat-icon>check</mat-icon>
            Confirmar
        </button>
    </mat-card-actions>
</mat-card>
